import request from "@/utils/request";

// 获取表单列表（回显）
export function template_diy_form_list(data) {
    return request({
        url: "/template/diy/form_list",
        method: "get",
        params: data,
    });
}

// 保存单个表单（新增/编辑）
export function template_diy_form_save(data) {
    return request({
        url: "/template/diy/form_save",
        method: "post",
        data,
    });
}

// 删除表单
export function template_diy_form_del(data) {
    return request({
        url: "/template/diy/form_del",
        method: "post",
        data,
    });
}

// 获取状态面板（回显，含状态值、变幻规则）
export function template_diy_state_list(data) {
    return request({
        url: "/template/diy/state_list",
        method: "get",
        params: data,
    });
}

// 保存单个状态面板（含状态值、变幻规则）
export function template_diy_state_save(data) {
    return request({
        url: "/template/diy/state_save",
        method: "post",
        data,
    });
}

// 删除状态面板
export function template_diy_state_del(data) {
    return request({
        url: "/template/diy/state_del",
        method: "post",
        data,
    });
}

// 上移 下移
export function template_diy_state_sort(data) {
    return request({
        url: "/template/diy/state_sort",
        method: "post",
        data,
    });
}
// 保存单个状态值（新增/编辑）
export function template_diy_state_item_save(data) {
    return request({
        url: "/template/diy/state_item_save",
        method: "post",
        data,
    });
}
// 删除单个状态值
export function template_diy_state_item_del(data) {
    return request({
        url: "/template/diy/state_item_del",
        method: "post",
        data,
    });
}
// 保存单个变幻规则（新增/编辑）
export function template_diy_rule_save(data) {
    return request({
        url: "/template/diy/rule_save",
        method: "post",
        data,
    });
}
// 删除单个变幻规则
export function template_diy_rule_del(data) {
    return request({
        url: "/template/diy/rule_del",
        method: "post",
        data,
    });
}